import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {FullTable} from "components";
import {renderSelectTrip, AddTrip} from "../../dispatchBoard";
import {legsActions} from "store";
import {
    emptyStatePatientTrips,
    patientTripsBody,
    patientTripsHead
} from "../constants";
import {limit, useModal} from "utils";

const ACTION_TYPE = 'GET_PATIENT_TRIPS';

export const PatientTrips = ({currentId, filters}) => {
    const [sendParams, setSendParams] = useState({
        skip: 0,
        limit: limit,
    });
    const patientTrips = useSelector((state) => state.legs?.patientTrips);
    const dispatch = useDispatch();
    const {openModal} = useModal();


    const getLegInfo = (noLoad) => {
        const params = {
            ...sendParams,
            ...filters,
            patient: currentId,
        };

        if (params?.page) delete params.page;

        dispatch(legsActions.getPatientTrips(params, noLoad))
    }

    useEffect(() => {
        getLegInfo();

        return () => {
            dispatch({
                type: 'GET_PATIENT_TRIPS_SUCCESS',
                payload: null,
            })
        }
    }, [sendParams, filters])


    const handleClickRow = (item) => {
        const tripDetails = renderSelectTrip.find(
            (r) => r?.tripDetails?.includeLegTypes?.includes(item.type)
        )?.tripDetails;

        openModal(
            <AddTrip
                tripId={item?.trip}
                tripDetails={tripDetails}
                afterSuccess={() => getLegInfo(true)}
                requestParams={{patient: currentId, ...filters}}
            />, {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 1400,
                dontClose: true,
            },
        );
    };

    return (
        <div>
            <FullTable
                head={patientTripsHead}
                body={patientTripsBody}
                list={patientTrips?.legs || []}
                listCount={patientTrips?.count}
                loadingType={ACTION_TYPE}
                emptyState={emptyStatePatientTrips}
                containerStyles={{height: "53vh", margin: 0}}
                getParams={setSendParams}
                currentParams={{page: filters?.page}}
                handleClick={handleClickRow}
            />
        </div>
    );
};
